<div [hidden]="isLoading">
	<!-- href="http://localhost:4200/assets/wdplugin-style.css" -->
	<link rel="stylesheet" [href]="cssUrlPage" />
	<div>
		<div class="p-t-m">
			<button mat-button color="accent" (click)="goBack()" id="goBackButton">
				<div fxLayoutAlign="start center">
					<img
						height="16px"
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/arrowBackAccent/public"
					/>
					&nbsp;<span i18n="@@widget_list_back_link">Widget list</span>
				</div>
			</button>
		</div>
		<mat-card fxLayout="column" class="mat-elevation-z0">
			<mat-card
				fxLayout="row"
				fxLayout.md="column"
				fxLayout.xs="column"
				fxLayout.sm="column"
				class="left-side mat-elevation-z0"
			>
				<div fxLayout="column" fxFlex="55">
					<div class="p-l-m">
						<mat-card-title
							class="mat-card-title"
							*ngIf="shortcode === 'create'; else editWidget"
							i18n="@@widget_button_create_widget"
						>
							Create Widget
						</mat-card-title>

						<ng-template #editWidget>
							<mat-card-title class="mat-card-title" i18n="@@widget_edit_title">
								Edit Widget
							</mat-card-title>
						</ng-template>
					</div>
					<mat-card
						fxFlex="60"
						class="mat-elevation-z0"
						id="appearance-option-section"
					>
						<mat-card-content>
							<div id="appearance-option-section">
								<!-- <h2 for="select-apperance-label">Widget Fundraiser Options</h2> -->
								<div fxLayout="column">
									<mat-form-field appearance="outline">
										<mat-label
											for="fundraiser-list-dropdown"
											i18n="@@widget_table_heading_fundraiser_name"
											>Fundraiser Name</mat-label
										>
										<mat-select
											id="fundraiser-list-dropdown"
											[(value)]="selectedFundraiser"
											(selectionChange)="onFundraiserSelectionChange()"
											[placeholder]="shortcode === 'create' ? 'Select Fundraiser' : ''"
										>
											<mat-option
												*ngFor="let fundraiser of fundraiser_list; let i = index"
												[value]="i"
											>
												{{ fundraiser.title }}
											</mat-option>
										</mat-select>
										<mat-hint
											class="mat-error"
											align="end"
											*ngIf="selectedFundraiser === -1"
										>
											<span i18n="@@widget_form_select_fundraiser_matError">
												Please select a fundraiser
											</span>
										</mat-hint>
									</mat-form-field>

									<div
										class="m-b-s"
										fxLayout="row"
										fxLayoutAlign="start center"
									>
										<mat-slide-toggle
											id="show-donate-button-only"
											name="show-donate-button-only"
											[(ngModel)]="showDonateCard"
											(change)="onShowDonateButtonOnly()"
											color="primary"
										></mat-slide-toggle>
										<label
											for="show-donate-button-only"
											i18n="@@widget_form_show_donate_button_only"
											>Show Card</label
										>
									</div>

									<mat-checkbox
										color="primary"
										type="checkbox"
										id="select-background-image-show"
										name="select-background-image-show"
										[(ngModel)]="showMainImageChecked"
										(change)="showMainImage()"
										[disabled]="!showDonateCard"
										i18n="@@widget_form_show_main_image"
										>Show Main Image</mat-checkbox
									>
									<mat-checkbox
										color="primary"
										type="checkbox"
										id="select-show-donate-form-only"
										name="select-show-only-donate-form"
										[(ngModel)]="showDonationFormOnlyChecked"
										(change)="onshowDonationFormOnly()"
										[disabled]="!showDonateCard"
										i18n="@@widget_form_fixed_form"
										>Pop UP/Fixed Form</mat-checkbox
									>
								</div>

								<!-- <label id="show-appearance-error" style="display: none"></label> -->
							</div>

							<div id="select-interval-section">
								<div class="m-t-s m-b-s"></div>
								<!-- Temporary div for space -->
								<h2
									for="select-interval-label"
									i18n="@@widget_form_donation_amount_optional"
								>
									Donation Amount (Optional)
								</h2>
								<div id="select-interval-options">
									<div
										class="m-b-s"
										fxLayout="row"
										fxLayoutAlign="start center"
									>
										<mat-slide-toggle
											id="select-interval-onetime"
											name="select-interval-onetime"
											[(ngModel)]="showHideOneTimeChecked"
											(change)="onshowHideOneTime();change_onetime($event)"
											color="primary"
										></mat-slide-toggle>
										<label
											for="select-interval-onetime"
											i18n="@@widget_form_one_time"
											>One time</label
										>
									</div>

									<div
										[style.display]="!showHideOneTimeChecked ? 'none' : 'block'"
										fxLayout="row"
										class="m-t-s m-b-s grey-button-toggle-group"
										fxLayoutAlign="start center"
									>
										<mat-button-toggle-group
											[(ngModel)]="onetimeOpenAmountChecked"
											(change)="openorcustomamount()"
											class="custom-button-toggle-group"
										>
											<mat-button-toggle
												[value]="false"
												i18n="@@widget_form_custom_amount"
												>Custom Amount
											</mat-button-toggle>
											<mat-button-toggle
												[value]="true"
												i18n="@@widget_form_open_amount"
												>Open Amount</mat-button-toggle
											>
										</mat-button-toggle-group>
									</div>

									<div
										[style.display]="!showHideOneTimeChecked ? 'none' : 'block'"
									>
										<div [hidden]="onetimeOpenAmountChecked">
											<div
												fxLayout="row wrap"
												fxLayoutGap="10px"
												id="select-amount-options"
											>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														type="number"
														id="select-first-amount"
														name="select-amount-value-first"
														[(ngModel)]="valueChangeFirstAmount"
														(input)="changeFirstAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeFirstAmount < this.currencyMinAmount || valueChangeFirstAmount > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeFirstAmount < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeFirstAmount > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-second"
														id="select-second-amount"
														[(ngModel)]="valueChangeSecondAmount"
														(input)="changeSecondAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeSecondAmount < this.currencyMinAmount || valueChangeSecondAmount > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeSecondAmount < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeSecondAmount > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-third"
														id="select-third-amount"
														[(ngModel)]="valueChangeThirdAmount"
														(input)="changeThirdAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeThirdAmount < this.currencyMinAmount || valueChangeThirdAmount > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeThirdAmount < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeThirdAmount > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-forth"
														id="select-forth-amount"
														[(ngModel)]="valueChangeFourthAmount"
														(input)="changeForthAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeFourthAmount < this.currencyMinAmount || valueChangeFourthAmount > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeFourthAmount < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeFourthAmount > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-forth"
														id="select-forth-amount"
														[(ngModel)]="valueChangeFifthAmount"
														(input)="changeFifthAmount()"
													/>
													<mat-error
														class="mat-error"
														*ngIf="valueChangeFifthAmount < this.currencyMinAmount || valueChangeFifthAmount > this.currencyMaxAmount"
													>
														<span [hidden]="!(valueChangeFifthAmount < this.currencyMinAmount)">
															<span i18n="@@donation_donation_form_minimum5_matError">
																Minimum is
															</span>
															<span>
																&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
															</span>
														</span>
														<span [hidden]="!(valueChangeFifthAmount > this.currencyMaxAmount)">
															<span i18n="@@custom_donation_form_amountTargetMax_error">
																Maximum is
															</span>
															<span>
																&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
															</span>
														</span>
													</mat-error>
												</mat-form-field>
											</div>
										</div>
										<!-- <label id="show-amount-error"></label> -->
									</div>

									<div
										class="m-b-s"
										fxLayout="row"
										fxLayoutAlign="start center"
									>
										<mat-slide-toggle
											color="primary"
											id="select-interval-monthly"
											name="select-interval-monthly"
											[(ngModel)]="showHideMonthlyChecked"
											(change)="onshowHideMonthly();change_monthly($event)"
										></mat-slide-toggle>
										<label
											for="select-interval-monthly"
											i18n="@@donation_form_monthly_label"
											>Monthly</label
										>
									</div>

									<div
										[style.display]="!showHideMonthlyChecked ? 'none' : 'block'"
										fxLayout="row"
										class="m-t-s m-b-s"
										fxLayoutAlign="start center"
									>
										<mat-button-toggle-group
											id="open-amount-monthly"
											name="open-amount-monthly"
											[(ngModel)]="monthlyOpenAmountChecked"
											(change)="openorcustomamount_monthly()"
											class="custom-button-toggle-group"
										>
											<mat-button-toggle
												[value]="false"
												i18n="@@widget_form_custom_amount"
												>Custom Amount
											</mat-button-toggle>
											<mat-button-toggle
												[value]="true"
												i18n="@@widget_form_open_amount"
												>Open Amount</mat-button-toggle
											>
										</mat-button-toggle-group>
									</div>

									<div
										[style.display]="!showHideMonthlyChecked ? 'none' : 'block'"
										id="select-amount-section-monthly"
									>
										<div [hidden]="monthlyOpenAmountChecked">
											<div
												fxLayout="row wrap"
												fxLayoutGap="10px"
												class="m-t-s"
												id="select-amount-options-monthly"
											>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														id="select-first-amount-monthly"
														name="select-amount-value-monthly"
														value="valueChangeFirstAmountMonthly"
														[(ngModel)]="valueChangeFirstAmountMonthly"
														(input)="changeFirstAmount()"
													/>													
												<mat-error
													class="mat-error"
													*ngIf="valueChangeFirstAmountMonthly < this.currencyMinAmount || valueChangeFirstAmountMonthly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeFirstAmountMonthly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeFirstAmountMonthly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-second"
														id="select-second-amount-monthly"
														value="valueChangeSecondAmountMonthly"
														[(ngModel)]="valueChangeSecondAmountMonthly"
														(input)="changeSecondAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeSecondAmountMonthly < this.currencyMinAmount || valueChangeSecondAmountMonthly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeSecondAmountMonthly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeSecondAmountMonthly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-third"
														id="select-third-amount-monthly"
														[(ngModel)]="valueChangeThirdAmountMonthly"
														(input)="changeThirdAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeThirdAmountMonthly < this.currencyMinAmount || valueChangeThirdAmountMonthly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeThirdAmountMonthly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeThirdAmountMonthly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-forth"
														id="select-forth-amount-monthly"
														[(ngModel)]="valueChangeFourthAmountMonthly"
														(input)="changeForthAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeFourthAmountMonthly < this.currencyMinAmount || valueChangeFourthAmountMonthly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeFourthAmountMonthly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeFourthAmountMonthly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
												<div matPrefix class="currency-input-field">
													{{ this.currencySymbol }}&nbsp;
												</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-forth"
														id="select-forth-amount"
														[(ngModel)]="valueChangeFifthAmountMonthly"
														(input)="changeFifthAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeFifthAmountMonthly < this.currencyMinAmount || valueChangeFifthAmountMonthly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeFifthAmountMonthly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeFifthAmountMonthly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
											</div>
										</div>
										<label id="show-amount-error-monthly"></label>
									</div>

									<div
										class="m-b-s"
										fxLayout="row"
										fxLayoutAlign="start center"
									>
										<mat-slide-toggle
											color="primary"
											id="select-interval-yearly"
											name="select-interval-yearly"
											checked
											[(ngModel)]="showHideYearlyChecked"
											(change)="onshowHideYearly();change_yearly($event)"
										></mat-slide-toggle>
										<label
											for="select-interval-onetime"
											i18n="@@donation_form_yearly_label"
											>Yearly</label
										>
									</div>

									<div
										[style.display]="!showHideYearlyChecked ? 'none' : 'block'"
									>
										<mat-button-toggle-group
											[(ngModel)]="yearlyOpenAmountChecked"
											class="m-t-s"
											(change)="openorcustomamount_yearly()"
											class="custom-button-toggle-group"
										>
											<mat-button-toggle
												[value]="false"
												i18n="@@widget_form_custom_amount"
												>Custom Amount</mat-button-toggle
											>
											<mat-button-toggle
												[value]="true"
												i18n="@@widget_form_open_amount"
												>Open Amount</mat-button-toggle
											>
										</mat-button-toggle-group>
									</div>

									<div class="m-t-s m-b-s">
										<!-- [style.display]="yearlyOpenAmountChecked ? 'none' : 'block'" -->
										<div [hidden]="yearlyOpenAmountChecked">
											<div
												[style.display]="!showHideYearlyChecked ? 'none' : 'block'"
												class="m-t-s m-b-s"
												fxLayoutGap="10px"
												fxLayout="row wrap"
												id="select-amount-section-yearly"
											>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														id="select-first-amount-yearly"
														name="select-yearly-amount-value-first"
														value="valueChangeFirstAmountYearly"
														[(ngModel)]="valueChangeFirstAmountYearly"
														(input)="changeFirstAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeFirstAmountYearly < this.currencyMinAmount || valueChangeFirstAmountYearly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeFirstAmountYearly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeFirstAmountYearly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-yearly-amount-value-second"
														id="select-second-amount-yearly"
														value="valueChangeSecondAmountYearly"
														[(ngModel)]="valueChangeSecondAmountYearly"
														(input)="changeSecondAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeSecondAmountYearly < this.currencyMinAmount || valueChangeSecondAmountYearly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeSecondAmountYearly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeSecondAmountYearly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-yearly-amount-value-second"
														id="select-third-amount-yearly"
														value="valueChangeThirdAmountYearly"
														[(ngModel)]="valueChangeThirdAmountYearly"
														(input)="changeSecondAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeThirdAmountYearly < this.currencyMinAmount || valueChangeThirdAmountYearly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeThirdAmountYearly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeThirdAmountYearly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
													<div matPrefix class="currency-input-field">
														{{ this.currencySymbol }}&nbsp;
													</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-forth"
														id="select-forth-amount-yearly"
														[(ngModel)]="valueChangeFourthAmountYearly"
														(input)="changeForthAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeFourthAmountYearly < this.currencyMinAmount || valueChangeFourthAmountYearly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeFourthAmountYearly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeFourthAmountYearly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
												
												<mat-form-field
													appearance="outline"
													color="primary"
													fxFlex="20"
												>
												
												<div matPrefix class="currency-input-field">
													{{ this.currencySymbol }}&nbsp;
												</div>
													<input
														color="primary"
														matInput
														type="number"
														min={{this.currencyMinAmount}}
														max={{this.currencyMaxAmount}}
														name="select-amount-value-forth"
														id="select-forth-amount"
														[(ngModel)]="valueChangeFifthAmountYearly"
														(input)="changeFifthAmount()"
													/>
												<mat-error
													class="mat-error"
													*ngIf="valueChangeFifthAmountYearly < this.currencyMinAmount || valueChangeFifthAmountYearly > this.currencyMaxAmount"
												>
													<span [hidden]="!(valueChangeFifthAmountYearly < this.currencyMinAmount)">
														<span i18n="@@donation_donation_form_minimum5_matError">
															Minimum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMinAmount}}
														</span>
													</span>
													<span [hidden]="!(valueChangeFifthAmountYearly > this.currencyMaxAmount)">
														<span i18n="@@custom_donation_form_amountTargetMax_error">
															Maximum is
														</span>
														<span>
															&nbsp;{{this.currencySymbol}}{{this.currencyMaxAmount}}
														</span>
													</span>
												</mat-error>
												</mat-form-field>
											</div>
										</div>
									</div>
									<label id="show-amount-error"></label>
								</div>

								<!-- <div
									fxLayout="row"
									class="select-amount-options"
									fxLayoutAlign="start center"
								>
									<mat-slide-toggle
										color="primary"
										id="select-other"
										name="select-amount-other"
										[(ngModel)]="showAmountOtherChecked"
										(change)="onshowOtherAmount()"
									></mat-slide-toggle>
									<label
										for="select-interval-onetime"
										i18n="@@widget_form_allow_other_amount"
										>Allow Other amount (Allow donor to decide donation
										amount)</label
									>
								</div>
								<label id="show-amount-error"></label> -->

								<!-- <label id="show-interval-error" style="display: none"></label> -->
							</div>

							<div class="m-t-m" id="customise-branding">
								<!-- <div fxLayout="row">
							<div>
								<h2 for="customise-braning-label">Styling</h2>
							</div>
							<div></div>
						</div> -->

								<mat-accordion>
									<mat-expansion-panel class="mat-elevation-z0">
										<mat-expansion-panel-header [style.paddingLeft.px]="0">
											<mat-panel-title>
												<h2
													i18n="@@stepsWidgetStyling_title"
													for="donation-form-label"
												>
													Styling
												</h2>
											</mat-panel-title>
										</mat-expansion-panel-header>
										<div
											fxLayout="row"
											class="m-t-s m-b-s"
											fxLayoutAlign="start center"
										>
											<div fxLayout="row" fxLayoutGap="4%" fxFill>
												<div fxLayout="column" fxLayoutAlign="center center">
													<p i18n="@@custom-branding-cardShadow">Card Shadow</p>
												</div>
												<div>
													<mat-card
														class="mat-elevation-z{{previewBoxShadowNumber}}"
													>
														<mat-button-toggle-group
															name="card-shadow"
															id="card-shadow"
															[(ngModel)]="boxShadowNumber"
															(change)="updateBoxShadow()"
															class="custom-button-toggle-group"
														>
															<mat-button-toggle
																[value]="1"
																name="card-shadow"
																id="card-shadow"
																i18n="@@widget_form_card_shadow_none"
																>None</mat-button-toggle
															>
															<mat-button-toggle
																[value]="2"
																name="card-shadow"
																id="card-shadow"
																i18n="@@custom-branding-card-shadow-medium"
																>Medium
															</mat-button-toggle>
															<mat-button-toggle
																[value]="3"
																name="card-shadow"
																id="card-shadow"
																i18n="@@custom-branding-card-shadow-high"
																>High
															</mat-button-toggle>
														</mat-button-toggle-group>
													</mat-card>
												</div>
											</div>
										</div>

										<div id="set-color">
											<mat-form-field
												fxFlex="50"
												appearance="outline"
												floatLabel="always"
												color="primary"
											>
												<mat-label
													i18n="@@custom-branding-set-primary-color-label"
													>Primary Color</mat-label
												>
												<input
													matInput
													type="text"
													placeholder="Ex. #ffff"
													id="set-color-input-field-primary"
													name="set-color-input-field-primary"
													[(ngModel)]="currentPrimaryColor"
													(change)="onchangePrimaryColor()"
												/>
												<button matSuffix mat-icon-button>
													<mat-icon class="material-icons-outlined">
														<input
															[style.cursor]="'pointer'"
															matInput
															type="color"
															id="set-color-input-primary"
															name="set-color-input-primary"
															[(ngModel)]="currentPrimaryColor"
															(change)="onchangePrimaryColor()"
														/>
													</mat-icon>
												</button>
											</mat-form-field>
											<mat-form-field
												fxFlex="50"
												class="m-l-s"
												appearance="outline"
												floatLabel="always"
												color="primary"
											>
												<mat-label
													i18n="@@custom-branding-set-secondary-color-label"
													>Secondary Color</mat-label
												>
												<input
													matInput
													type="text"
													placeholder="Ex. #ffff"
													id="set-color-input-field-secondary"
													name="set-color-input-field-secondary"
													[(ngModel)]="currentSecondaryColor"
													(change)="onchangeSecondaryColor()"
												/>
												<button matSuffix mat-icon-button>
													<mat-icon class="material-icons-outlined">
														<input
															[style.cursor]="'pointer'"
															matInput
															type="color"
															id="set-color-input-secondary"
															name="set-color-input-secondary"
															[(ngModel)]="currentSecondaryColor"
															(change)="onchangeSecondaryColor()"
														/>
													</mat-icon>
												</button>
											</mat-form-field>
										</div>
										<div id="set-button-radius">
											<mat-form-field fxFlex="50" appearance="outline">
												<mat-label
													i18n="@@widget_form_typography"
													for="selectTypo"
													>Typography</mat-label
												>
												<mat-select
													[(ngModel)]="widgetFontName"
													id="selectTypo"
													(selectionChange)="changeFontFamily()"
												>
													<mat-option
														i18n="@@widget_form_default_font_text"
														value="Default"
														>Default from your website</mat-option
													>
													<mat-option
														style="font-family: 'Roboto', sans-serif"
														value="Roboto"
														>Roboto</mat-option
													>
													<mat-option
														style="font-family: 'Raleway', sans-serif"
														id="raleway"
														value="Raleway"
														>Raleway</mat-option
													>
													<mat-option
														style="font-family: 'Amatic SC', sans-serif"
														value="Amatic SC"
														>Amatic SC</mat-option
													>
													<mat-option
														style="font-family: 'Caveat', sans-serif"
														value="Caveat"
														>Caveat</mat-option
													>
													<mat-option
														style="font-family: 'Comfortaa', sans-serif"
														value="Comfortaa"
														>Comfortaa</mat-option
													>
													<mat-option
														style="font-family: 'EB Garamond', sans-serif"
														value="EB Garamond"
														>EB Garamond</mat-option
													>
													<mat-option
														style="font-family: 'Lobster', sans-serif"
														value="Lobster"
														>Lobster</mat-option
													>
													<mat-option
														style="font-family: 'Lora', sans-serif"
														value="Lora"
														>Lora</mat-option
													>
													<mat-option
														style="font-family: 'Merriweather', sans-serif"
														value="Merriweather"
														>Merriweather</mat-option
													>
													<mat-option
														style="font-family: 'Montserrat', sans-serif"
														value="Montserrat"
														>Montserrat</mat-option
													>
													<mat-option
														style="font-family: 'Nunito', sans-serif"
														value="Nunito"
														>Nunito</mat-option
													>
													<mat-option
														style="font-family: 'Oswald', sans-serif"
														value="Oswald"
														>Oswald</mat-option
													>
													<mat-option
														style="font-family: 'Pacifico', sans-serif"
														value="Pacifico"
														>Pacifico</mat-option
													>
													<mat-option
														style="font-family: 'Playfair Display', sans-serif"
														value="Playfair Display"
														>Playfair Display
													</mat-option>
													<mat-option
														style="font-family: 'Spectral', sans-serif"
														value="Spectral"
														>Spectral</mat-option
													>
													<mat-option
														style="font-family: 'Open Sans', sans-serif"
														value="Open Sans"
														>Open Sans</mat-option
													>
													<mat-option
														style="font-family: 'Lato', sans-serif"
														value="Lato"
														>Lato</mat-option
													>
													<mat-option
														style="font-family: 'Yatra One', sans-serif"
														value="Yatra One"
														>Yatra One</mat-option
													>
													<mat-option
														style="font-family: 'Arvo', sans-serif"
														value="Arvo"
														>Arvo</mat-option
													>
													<mat-option
														style="font-family: 'Ubuntu', sans-serif"
														value="Ubuntu"
														>Ubuntu</mat-option
													>
													<mat-option
														style="font-family: 'PT Serif', sans-serif"
														value="PT Serif"
														>PT Serif</mat-option
													>
													<mat-option
														style="font-family: 'Slabo 13px', sans-serif"
														value="Slabo 13px"
														>Slabo</mat-option
													>
													<mat-option
														style="font-family: 'Source Sans Pro', sans-serif"
														value="Source Sans Pro"
														>Source Sans
													</mat-option>
													<mat-option
														style="font-family: 'PT Sans', sans-serif"
														value="PT Sans"
														>PT Sans</mat-option
													>
													<mat-option
														style="font-family: 'Noto Serif', sans-serif"
														value="Noto Serif"
														>Noto Serif</mat-option
													>
													<mat-option
														style="font-family: 'Nunito Sans', sans-serif"
														value="Nunito Sans"
														>Nunito Sans</mat-option
													>
													<mat-option
														style="font-family: 'Concert One', sans-serif"
														value="Concert One"
														>Concert One</mat-option
													>
													<mat-option
														style="font-family: 'Prompt', sans-serif"
														value="Prompt"
														>Prompt</mat-option
													>
													<mat-option
														style="font-family: 'Work Sans', sans-serif"
														value="Work Sans"
														>Work Sans</mat-option
													>
												</mat-select>
												<mat-hint
													class="mat-error"
													align="end"
													*ngIf="widgetFontName == ''"
												>
													<span i18n="@@widget_form_select_font_matError">
														Please select a font
													</span>
												</mat-hint>
											</mat-form-field>
											<mat-form-field
												fxFlex="50"
												id="set-button-radius"
												appearance="outline"
												color="primary"
												class="m-l-s"
											>
												<mat-label
													for="set-button-radius-label"
													i18n="@@widget_form_button_radius"
													>Button Radius</mat-label
												>
												<input
													matInput
													type="number"
													min="0"
													max="30"
													id="set-button-radius-input"
													name="set-button-radius-input"
													value="currentButtonRadius"
													[(ngModel)]="currentButtonRadius"
													(change)="onchangeButtonRadius()"
												/>
												<mat-hint
													class="mat-error"
													align="end"
													*ngIf="currentButtonRadius < 0 || currentButtonRadius > 30"
												>
													<span i18n="@@widgetform_range_matError">
														Range is in between 0 to 30
													</span>
												</mat-hint>
											</mat-form-field>
										</div>
									</mat-expansion-panel>
								</mat-accordion>
							</div>
							<!-- <div>
					<mat-label for="donation-form-label">Donation form title</mat-label>
					<input
						type="text"
						id="set-donation-form"
						name="set-donation-form"
						value="valuechangeDonationLabel"
						[(ngModel)]="valuechangeDonationLabel"
						(input)="onchangeDonationLabel()"
					/>
				</div> -->
							<!-- <mat-accordion>
								<mat-expansion-panel class="mat-elevation-z0">
									<mat-expansion-panel-header [style.paddingLeft.px]="0">
										<mat-panel-title>
											<h2
												for="donation-form-label"
												i18n="@@widget_form_redirection_links_styling_heading"
											>
												Redirection Links
											</h2>
										</mat-panel-title>
									</mat-expansion-panel-header>

									<mat-form-field
										appearance="outline"
										color="primary"
										ngClass="w-100"
									>
										<mat-label
											for="select-plugin-style-label"
											i18n="@@widget_form_donation_paid_link"
										>
											Donation Paid Link
										</mat-label>
										<input
											matInput
											name="fundraiser-success-url"
											id="fundraiser-success-url"
											[(ngModel)]="fundraiserSuccessUrl"
										/>
									</mat-form-field>
									<mat-form-field
										appearance="outline"
										color="primary"
										ngClass="w-100"
									>
										<mat-label
											for="select-plugin-style-label"
											i18n="@@widget_form_failed_paid_link"
										>
											Failed payment redirect URL
										</mat-label>
										<input
											matInput
											name="fundraiser-failure-url"
											id="fundraiser-failure-url"
											[(ngModel)]="fundraiserFailUrl"
										/>
									</mat-form-field>
								</mat-expansion-panel>
							</mat-accordion> -->
							<div fxLayout="column" fxLayoutAlign="start start" fxfill>
								<div fxLayout="row">
									<button
										[disabled]="disabled"
										mat-flat-button
										color="accent"
										id="set-plugin-style"
										(click)="save_code()"
									>
										<span i18n="@@widget_form_button_save_code">Save code</span>
									</button>
								</div>
							</div>
						</mat-card-content>
					</mat-card>
				</div>
				<mat-card fxFlex="45" fxLayout="column" class="mat-elevation-z0">
					<mat-card class="grey-bg" fxFlex>
						<div>
							<div
								fxLayout="row"
								fxFlex="100%"
								fxFill
								fxLayoutAlign="none start"
							>
								<div fxLayout="row" ngClass.lt-sm="m-t-m">
									<img
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/visibilityOn/public"
									/>
									<span i18n="@@button_preview" fxFlexOffset="8px">
										Preview
									</span>
								</div>
							</div>
						</div>
						<div id="preview_box" fxLayoutAlign="center none" fxfill>
							<div
								id="preview_box_widget"
								[style.marginTop.px]="40"
								[style.width.px]="400"
								[hidden]="showDonationFormOnlyChecked"
								[style.transform]="(screenWidth < 420 ? 'scale(0.5)' : (screenWidth < 800 ? 'scale(0.8)' : ( screenWidth < 1280 ? 'none' :  (screenWidth < 1371 ? 'scale(0.75)' : 'none'))))"
								[innerHTML]="donation_box"
							></div>
							<!-- "-30" to cancel out margin from preview css -->
							<div
								[style.marginLeft.px]="-30"
								[style.transform]="(screenWidth < 420 ? 'scale(0.5)' : (screenWidth < 800 ? 'scale(0.8)' : ( screenWidth < 1280 ? 'none' :  (screenWidth < 1371 ? 'scale(0.75)' : (screenWidth < 1500 ? 'scale(0.70)' : (screenWidth > 1500 ? 'scale(0.80)' : ''))))))"
								[hidden]="!showDonationFormOnlyChecked"
								[innerHTML]="donation_window_modal"
							></div>
						</div>
					</mat-card>
				</mat-card>
			</mat-card>
			<mat-card class="mat-elevation-z0">
				<mat-card
					fxLayout="column"
					fxLayoutAlign="end stretch"
					fxLayoutGap="10"
					class="mat-elevation-z0"
				>
					<div fxLayout="column" fxFlex>
						<div i18n="@@embed_copyAndPaste_label" class="mat-subtitle-1 p-l-m">Code to copy:</div>
						<div
							class="grey-bg mat-subtitle-1"
							ngClass="p-l-s p-t-xs p-b-xs"
							fxLayout="column"
						>
							<!-- Ensure full height -->
							<div
								fxFlex
								[style.marginLeft.px]="10"
								[style.marginRight.px]="10"
								[style.marginTop.px]="10"
								[style.marginBottom.px]="10"
								i18n="@@widget_form_copy_text"
								*ngIf="shortcode === 'create'"
							>
								Please save the widget first
							</div>

							<div
								fxFlex
								[style.marginLeft.px]="10"
								[style.marginRight.px]="10"
								[style.marginTop.px]="10"
								[style.marginBottom.px]="10"
								*ngIf="shortcode !== 'create'"
							>
								{{ generatedWidgetHTML }}
							</div>

							<div
								fxLayout="row"
								fxLayoutAlign="end center"
								*ngIf="shortcode !== 'create'"
							>
								<div fxFlex></div>
								<!-- This div takes up remaining space -->
								<button
									(mousedown)="onMouseDown(shortcode)"
									(mouseup)="onMouseUp(shortcode)"
									(click)="copyHtmlCode(shortcode)"
									[style.color]="buttonStates[shortcode] ? '#51d171' : null"
									class="copyLink hover-class"
									matTooltip="{{ matTooltip }}"
									mat-icon-button
								>
									<mat-icon size="3x">content_copy</mat-icon>
								</button>
							</div>
						</div>
					</div>
				</mat-card>
			</mat-card>
		</mat-card>
	</div>
</div>
<div [hidden]="!isLoading">
	<ng-container *ngIf="isLoading; else whydonateLoader">
		<app-page-loader></app-page-loader>
	</ng-container>
</div>

<!-- Page loader / whydonate loader -->
<ng-template #whydonateLoader>
	<app-page-loader></app-page-loader>
</ng-template>
